        import { initializeApp } from "firebase/app";
import { FacebookAuthProvider, getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCWLIYTeEH9wz8UrUmugFLHIeG7-CbdzpM",
  authDomain: "fcis-40762.firebaseapp.com",
  projectId: "fcis-40762",
  storageBucket: "fcis-40762.appspot.com",
  messagingSenderId: "435649475005",
  appId: "1:435649475005:web:e9b3fb510fe7333206a2d4",
  measurementId: "G-NEJXR56Y57",
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const provider = new GoogleAuthProvider();
const facebookporvider = new FacebookAuthProvider();
const auth = getAuth(app);

export {auth, provider,facebookporvider,app};
